'use client';

import { withRequiredPermission } from '@/components/auth/with-required-permission';
import { PERMISSIONS } from '@/hooks/use-perm';
import { useTranslation } from 'react-i18next';
import { AuthorizeNetProcessorEditPage } from './components/authorizenet-processor-edit-page';
import { useProcessorById } from '@/lib/api/processors';
import { useProcessorEditId } from '@/app/processors/hooks/use-processor-edit-id';
import { ErrorDisplay } from '@/components/ui/error-display';
import { parseTRPCError } from '@/lib/utils/trpc-error-utils';

const AuthorizeNetEditPageContainerInner = () => {
    const { t } = useTranslation('processors');
    const id = useProcessorEditId();
    const { data, isLoading, error } = useProcessorById(id);

    if (isLoading) {
        return (
            <div className="container mx-auto py-8">
                <div className="animate-pulse space-y-6">
                    <div className="h-8 w-1/3 rounded bg-gray-200"></div>
                    <div className="space-y-4">
                        <div className="h-32 rounded bg-gray-200"></div>
                        <div className="h-32 rounded bg-gray-200"></div>
                        <div className="h-32 rounded bg-gray-200"></div>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return <ErrorDisplay error={parseTRPCError(error)} />;
    }

    if (!data) {
        return <div className="container mx-auto py-8">{t('processorNotFound')}</div>;
    }

    return <AuthorizeNetProcessorEditPage processor={data} />;
};

export const AuthorizeNetEditPageContainer = withRequiredPermission(AuthorizeNetEditPageContainerInner, PERMISSIONS.PROCESSORS_MANAGE);
export default AuthorizeNetEditPageContainer;
